export default "__VITE_ASSET__DG7xd_IF__"